import { render, staticRenderFns } from "./KerkViewer.vue?vue&type=template&id=0f3708f1"
import script from "./KerkViewer.vue?vue&type=script&lang=js"
export * from "./KerkViewer.vue?vue&type=script&lang=js"
import style0 from "./KerkViewer.vue?vue&type=style&index=0&id=0f3708f1&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports